import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceOnboardingService {
  // private readonly vehicleUrl = 'http://192.168.176.99:3000/api/v1/vehicle';
  private readonly vehicleUrl = environment.vehicleUrl;
  private readonly deviceUrl = environment.deviceUrl;
  private readonly testUrl = environment.testUrl;


  constructor(private http: HttpClient) { }
  // SIGNUP  API
  deviceClaim(payload: any) {
    return this.http.post(`${this.deviceUrl}/claim`, payload);
  }
  /* ================= LINK VEHICLE ================= */
  linkVehicle(payload: any) {
    return this.http.post(`${this.vehicleUrl}/link`, payload);

  }
  verifyRto(vehicleNumber: any) {
    return this.http.post(`${this.vehicleUrl}/checkRto`, {
      rtoNumber: vehicleNumber
    });
  }
  verifyOwner(payload: any) {
    return this.http.post(`${this.vehicleUrl}/verifyOwner`, payload);
  }

  /* ================= PERSONALISE ================= */
  personaliseVehicle(payload:any) {

    return this.http.post(`${this.vehicleUrl}/personalize`, payload);
  }
  /* ================= ONBOARDING SOURCE OF TRUTH ================= */

  checkPending() {
    return this.http.get(`${this.vehicleUrl}/onboarding/pending`);
  }
  getVehicleImages() {
  return this.http.get(`${this.testUrl}/vehicle-images`);
}
}
